import type {FC} from 'react';
import {styled} from 'styled-components';

import type {TmdbWatchProvider} from '@repo/shared/api/website_api';

import {Tooltip} from '@repo/shared-web/components/core/tooltip';

interface WatchProviderProps {
  provider: TmdbWatchProvider;
}

export const WatchProvider: FC<WatchProviderProps> = ({provider}) => {
  const {logo_path, provider_name} = provider;
  const logoUrl = `https://image.tmdb.org/t/p/original${logo_path}`;
  return (
    <Tooltip content={provider_name}>
      <Wrapper>
        <img src={logoUrl} height={32} />
      </Wrapper>
    </Tooltip>
  );
};

WatchProvider.displayName = 'WatchProvider';

const Wrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  width: 32px;
  height: 32px;
`;
